import { imagePath } from '@ui/helpers'
import Image from 'next/image'
import { StarIcon } from '../shared/icons/StarIcon'
import { AppStoreBadge } from './AppStoreBadge'
import classes from './LandingMain.module.css'
import { Ornament } from './Ornament'

const deepLink = 'https://apps.apple.com/us/app/shophelp-senior-comfort-bras/id6753154632'

export const LandingMain = () => {
  return (
    <main className={classes.root}>
      <div className={classes['phone-mock-lg']}>
        <Image
          alt="Shophelp"
          height={666}
          priority
          placeholder="blur"
          blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8e/9pGgAIywMpDsJJdAAAAABJRU5ErkJggg=="
          src={imagePath('t/s/i/shophelp-landing-alt.webp')}
          unoptimized
          width={475}
        />
      </div>
      <h1 className={classes.title}>
        <Ornament className={classes.ornament} />
        Comfort Essentials.
        <br />
        {`Shop with Ease &
        Value Smart.`}
      </h1>
      <p className={classes.description}>
        Everyday wear should feel soft, simple, and dignified. With ShopHelp, seniors can enjoy
        apparel that slip on with ease, fit comfortably all day, and bring confidence with
        affordable prices that truly care.
      </p>
      <div className={classes.cta}>
        <div className={classes['phone-mock']}>
          <Image
            height={520}
            priority
            placeholder="blur"
            blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8e/9pGgAIywMpDsJJdAAAAABJRU5ErkJggg=="
            src={imagePath('t/s/i/shophelp-landing-mobile.webp')}
            unoptimized
            width={350}
          />
        </div>
        <div className={classes.appstore}>
          <div className={classes['badge-group']}>
            <a href={deepLink} className={classes.badge}>
              <AppStoreBadge />
            </a>
            <div className={classes.rating}>
              <p className={classes['rating-text']}>4.9 overall rating</p>
              <div className={classes['rating-stars']}>
                {Array(5)
                  .fill(0)
                  .map((_, i) => (
                    <StarIcon key={i} />
                  ))}
              </div>
            </div>
          </div>
          <div className={classes['qr-code-wrapper']}>
            <div className={classes['qr-code']}>
              <div className={classes['qr-code-inner']}>
                <Image
                  className={classes['qr-code-image']}
                  src={imagePath('t/s/i/shophelp_QRCode.webp')}
                  unoptimized
                  blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNsqAcAAYUBAdpOiIkAAAAASUVORK5CYII="
                  placeholder="blur"
                  layout="fill"
                />
              </div>
            </div>
            <div className={classes['qr-label']}>SCAN HERE</div>
          </div>
        </div>
      </div>
    </main>
  )
}
